module.exports = __webpack_public_path__ + "965a9fc8ef2907120a78c8deb543d9df.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/logo-banner.png
// module id = 659
// module chunks = 0